document.querySelectorAll('.payment_text').forEach(text => {
    text.addEventListener('click', () => {
        let popupValue = text.closest('.payment_wrapper').getAttribute('data-popup');
        let productCard = text.closest('product-card');
        let nextDivs = [];
        let sibling = productCard.nextElementSibling;
        while (sibling && nextDivs.length < 2) {
            if (sibling.tagName.toLowerCase() === 'div') {
                nextDivs.push(sibling);
            }
            sibling = sibling.nextElementSibling;
        }
        nextDivs.forEach(div => {
            if (div.classList.contains(popupValue)) {
                div.classList.add('term-popup-open');
            }
        });
    });
});



document.querySelectorAll('.popup-close-btn').forEach(button => {
    button.addEventListener('click', () => {
        document.querySelectorAll('.popup-payment-term').forEach(term => {
            term.classList.remove('term-popup-open');
        });
    });
});

setTimeout(() => {
  document.querySelectorAll(".review_count").forEach(function (element) {
    const strong = element.querySelector("strong");
    if (strong && strong.textContent.trim() === "") {
      const randomNumber = Math.floor(Math.random() * (50 - 20 + 1)) + 20;
      strong.textContent = randomNumber;
    }
  });
}, 1000);

 


document.addEventListener("DOMContentLoaded", () => {
  const row = document.querySelector(".product_multicolumn .multicolumn__inner .row");

  if (!row) return;

  // Make sure parent is positioned
  const wrapper = row.closest(".product_multicolumn");
  if (wrapper) wrapper.style.position = "relative";

  // Create arrows
  const leftArrow = document.createElement("button");
  leftArrow.className = "arrow left";
  leftArrow.textContent = "‹";

  const rightArrow = document.createElement("button");
  rightArrow.className = "arrow right";
  rightArrow.textContent = "›";

  // Append arrows directly inside wrapper
  wrapper.appendChild(leftArrow);
  wrapper.appendChild(rightArrow);

  // Scroll logic
  leftArrow.addEventListener("click", () => {
    row.scrollBy({ left: -250, behavior: "smooth" });
  });

  rightArrow.addEventListener("click", () => {
    row.scrollBy({ left: 250, behavior: "smooth" });
  });
});

